export default __webpack_public_path__ + "static/intern-soham-sonawane-5d4e1b20a6080152cb124a0ff26f54f4.webp";